import React from "react";

interface Props {
    value: boolean | undefined;
    trueLabel: string;
    falseLabel: string;
}

export const BooleanFilterLabel: React.FC<Props> = ({
    value,
    trueLabel,
    falseLabel,
}) => {
    if (value === true) {
        return <span>{trueLabel}</span>;
    }
    if (value === false) {
        return <span>{falseLabel}</span>;
    }
    return null;
};
